module.exports = __webpack_public_path__ + "static/img/10.c68ca34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productcenter/10.png
// module id = S3hL
// module chunks = 1